export default __webpack_public_path__ + "img/43427360697701c9432936d43eedbf9f.svg";